import {ActionHandlerBase} from "../action-handler-base";
import {
    ClientPageType,
    IOpenClientPageActionPayload
} from "@sparkware/uc-sdk-core";

export class OpenClientPageActionHandler extends ActionHandlerBase<IOpenClientPageActionPayload> {
    async handle(payload: IOpenClientPageActionPayload): Promise<void> {
        switch(payload.actionData.clientPageType) {
            case ClientPageType.rgPolicy:
                await this.services.linksNavigation.openResponsibleGaming();
                break;
            case ClientPageType.onlineHelp:
                // TODO: Implement
                throw new Error(`Client page ${payload.actionData.clientPageType} is not supported yet`);
            default:
                throw new Error(`Client page ${payload.actionData.clientPageType} is not supported`);
        }
    }
}
